export default function KnowledgeCard({ title, description }) {
  return (
    <div
      style={{
        border: "1px solid #ddd",
        borderRadius: "8px",
        padding: "20px",
        width: "300px",
        boxShadow: "0 2px 5px rgba(0,0,0,0.1)"
      }}
    >
      <h3>{title}</h3>

      <p>{description}</p>

      <button
        style={{
          marginTop: "10px",
          padding: "8px 12px",
          background: "#0f172a",
          color: "white",
          border: "none",
          cursor: "pointer"
        }}
      >
        Read More
      </button>
    </div>
  );
}